var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFE4E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.0002H33.75V44.6252C33.75 46.316 33.0784 47.9375 31.8828 49.133C30.6873 50.3286 29.0658 51.0002 27.375 51.0002C25.6842 51.0002 24.0627 50.3286 22.8672 49.133C21.6716 47.9375 21 46.316 21 44.6252V21.0002Z",
    stroke: "#F63866",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7497 28.5002L39.7497 22.5002L48.7497 31.5002L33.1797 47.0702",
    stroke: "#F63866",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51.0002H51V38.2502H42",
    stroke: "#F63866",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30.0002H33.75",
    stroke: "#F63866",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39.7502H33.75",
    stroke: "#F63866",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsDesign);
export default __webpack_public_path__ + "static/media/DevOps_Design.58fb9c39b334767a9b7aef86bc3ee2b8.svg";
export { ForwardRef as ReactComponent };